import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import About from './pages/About';
import SriLanka from './pages/SriLanka';
import TourPackages from './pages/TourPackages';
import ThingsToDo from './pages/ThingsToDo';
import Bookings from './pages/Bookings';
import ContactUs from './pages/ContactUs';
import Japan from './pages/Japan';
import AyurvedaPage from './pages/AyurvedaPage';
import DivingPage from './pages/DivingPage';
import ElephantRidePage from './pages/ElephantRidePage';
import FishingPage from './pages/FishingPage';
import BallooningPage from './pages/BallooningPage';
import JeepSafariPage from './pages/JeepSafariPage';
import WhiteWaterRaftingPage from './pages/WhiteWaterRaftingPage';
import RiverSafariPage from './pages/RiverSafariPage';
import SnorkelingPage from './pages/SnorkelingPage';
import TeaTastingPage from './pages/TeaTastingPage';
import TempleVisitPage from './pages/TempleVisitPage';
import WildlifeSafariPage from './pages/WildlifeSafariPage';
import WhatsApp from './components/WhatsApp';
import TikTok from './components/TikTok';
import Instagram from './components/Instagram';
import Gallery from './pages/Gallery';
import Events from './pages/Events';

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Sonic Tours - Discover Moragalla, Beruwala & Sri Lanka"
                  description="Join Sonic Tours for unforgettable journeys from Moragalla, Beruwala — beaches, river safaris, wildlife, culture, and personalized Sri Lanka tours."
                  keywords="Sonic Tours, Sonic Tours Sri Lanka, Beruwala Tours, Sri Lanka Tours, Wildlife Safaris Sri Lanka, Beach Holidays Sri Lanka, River Safari Bentota"
                  url="https://sonictourssl.com"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <SEO
                  title="About Us - Sonic Tours Sri Lanka"
                  description="Meet Sonic Tours — your trusted local tour operator offering authentic, personalized travel experiences from Moragalla, Beruwala, and across the island."
                  keywords="Sonic Tours, About Sonic Tours, Sri Lanka Tour Operator, Beruwala Tours, Nethaj Tours"
                  url="https://sonictourssl.com/about-us"
                />
                <About />
              </>
            }
          />
          <Route
            path="/srilanka"
            element={
              <>
                <SEO
                  title="Explore Sri Lanka - Sonic Tours"
                  description="Discover the beauty of Sri Lanka with Sonic Tours — golden beaches of Moragalla, Beruwala, wildlife safaris, ancient temples, and misty hill country."
                  keywords="Explore Sri Lanka, Sonic Tours, Beruwala Beach, Sri Lanka Travel, Nature Tours, Wildlife Safari"
                  url="https://sonictourssl.com/srilanka"
                />
                <SriLanka />
              </>
            }
          />
          <Route
            path="/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Sonic Tours Sri Lanka"
                  description="Explore our handpicked tour packages from Sonic Tours — beach getaways, wildlife adventures, cultural journeys, and more."
                  keywords="Sri Lanka Tour Packages, Sonic Tours, Beruwala Tours, Wildlife Tours, Beach Holidays"
                  url="https://sonictourssl.com/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Sonic Tours Sri Lanka"
                  description="See beautiful moments from Sonic Tours journeys — beaches of Moragalla, Beruwala, wildlife, temples, and Sri Lanka's magic captured."
                  keywords="Sri Lanka Photos, Sonic Tours Gallery, Beruwala Beach, Travel Memories"
                  url="https://sonictourssl.com/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/events"
            element={
              <>
                <SEO
                  title="Special Events - Sonic Tours Sri Lanka"
                  description="Experience Sri Lanka's vibrant festivals and cultural events with Sonic Tours — from Kandy Perahera to local celebrations."
                  keywords="Sri Lanka Events, Sonic Tours, Cultural Festivals, Kandy Perahera, Local Experiences"
                  url="https://sonictourssl.com/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/things"
            element={
              <>
                <SEO
                  title="Things to Do - Sonic Tours Sri Lanka"
                  description="Discover exciting activities with Sonic Tours — river safaris, wildlife, diving, tea tasting, and more."
                  keywords="Things To Do Sri Lanka, Sonic Tours, Wildlife Safari, Adventure Activities"
                  url="https://sonictourssl.com/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Sonic Tours Sri Lanka"
                  description="Book your perfect Sri Lanka tour easily with Sonic Tours. Custom trips, beach holidays, safaris — starting from Moragalla, Beruwala."
                  keywords="Book Sri Lanka Tours, Sonic Tours Bookings, Beruwala Tours, Travel Reservations"
                  url="https://sonictourssl.com/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Sonic Tours Sri Lanka"
                  description="Get in touch with Sonic Tours for bookings, inquiries, or custom tours. Reach us via WhatsApp, email or phone."
                  keywords="Contact Sonic Tours, Sri Lanka Tour Contact, Beruwala Tours, Travel Inquiries"
                  url="https://sonictourssl.com/contact-us"
                />
                <ContactUs />
              </>
            }
          />
          <Route
            path="/contact-japan"
            element={
              <>
                <SEO
                  title="Contact Japan - Sonic Tours Sri Lanka"
                  description="Get in touch with Sonic Tours Japan office for bookings, inquiries, or custom tours. Reach us via WhatsApp, email or phone."
                  keywords="Contact Sonic Tours Japan, Sri Lanka Tour Contact, Japan Office, Travel Inquiries"
                  url="https://sonictourssl.com/contact-japan"
                />
                <Japan />
              </>
            }
          />

          {/* Things To Do Individual Pages */}
          <Route
            path="/ayurveda"
            element={
              <>
                <SEO
                  title="Ayurveda & Wellness - Sonic Tours Sri Lanka"
                  description="Relax and heal with authentic Ayurveda treatments and wellness experiences arranged by Sonic Tours."
                  keywords="Ayurveda Sri Lanka, Sonic Wellness, Beruwala Wellness, Spa Packages"
                  url="https://sonictourssl.com/ayurveda"
                />
                <AyurvedaPage />
              </>
            }
          />
          <Route
            path="/diving"
            element={
              <>
                <SEO
                  title="Scuba Diving - Sonic Tours Sri Lanka"
                  description="Dive into Sri Lanka's colorful underwater world with guided diving trips from Sonic Tours."
                  keywords="Diving Sri Lanka, Sonic Tours Diving, Marine Adventures"
                  url="https://sonictourssl.com/diving"
                />
                <DivingPage />
              </>
            }
          />
          <Route
            path="/elephant-ride"
            element={
              <>
                <SEO
                  title="Elephant Experiences - Sonic Tours Sri Lanka"
                  description="Meet Sri Lanka's gentle giants responsibly with Sonic Tours — ethical elephant interactions and safaris."
                  keywords="Elephant Safari Sri Lanka, Sonic Tours, Wildlife Experiences"
                  url="https://sonictourssl.com/elephant-ride"
                />
                <ElephantRidePage />
              </>
            }
          />
          <Route
            path="/fishing"
            element={
              <>
                <SEO
                  title="Fishing Trips - Sonic Tours Sri Lanka"
                  description="Enjoy deep-sea and lagoon fishing adventures along Sri Lanka's coast with Sonic Tours."
                  keywords="Fishing Sri Lanka, Sonic Tours, Beruwala Fishing"
                  url="https://sonictourssl.com/fishing"
                />
                <FishingPage />
              </>
            }
          />
          <Route
            path="/ballooning"
            element={
              <>
                <SEO
                  title="Hot Air Ballooning - Sonic Tours Sri Lanka"
                  description="Float above Sri Lanka's stunning landscapes on a magical hot air balloon ride with Sonic Tours."
                  keywords="Hot Air Ballooning Sri Lanka, Sonic Tours Adventure, Scenic Flights"
                  url="https://sonictourssl.com/ballooning"
                />
                <BallooningPage />
              </>
            }
          />
          <Route
            path="/jeep-safari"
            element={
              <>
                <SEO
                  title="Jeep Safari - Sonic Tours Sri Lanka"
                  description="Experience thrilling jeep safaris in Sri Lanka's national parks with expert guides from Sonic Tours."
                  keywords="Jeep Safari Sri Lanka, Sonic Tours Wildlife, Yala Safari, Udawalawe Safari"
                  url="https://sonictourssl.com/jeep-safari"
                />
                <JeepSafariPage />
              </>
            }
          />
          <Route
            path="/white-water-rafting"
            element={
              <>
                <SEO
                  title="White Water Rafting - Sonic Tours Sri Lanka"
                  description="Feel the thrill of white water rafting in Kitulgala with safe, guided tours from Sonic Tours."
                  keywords="White Water Rafting Sri Lanka, Sonic Tours Adventures, Kitulgala Rafting"
                  url="https://sonictourssl.com/white-water-rafting"
                />
                <WhiteWaterRaftingPage />
              </>
            }
          />
          <Route
            path="/river-safari"
            element={
              <>
                <SEO
                  title="River Safari - Sonic Tours Sri Lanka"
                  description="Cruise the beautiful Bentota River on a relaxing safari with Sonic Tours."
                  keywords="River Safari Bentota, Sonic Tours Nature Tours, Bentota Boat Ride"
                  url="https://sonictourssl.com/river-safari"
                />
                <RiverSafariPage />
              </>
            }
          />
          <Route
            path="/snorkeling"
            element={
              <>
                <SEO
                  title="Snorkeling - Sonic Tours Sri Lanka"
                  description="Explore colorful coral reefs and tropical fish with snorkeling trips arranged by Sonic Tours."
                  keywords="Snorkeling Sri Lanka, Sonic Tours Marine Tours, Beach Activities"
                  url="https://sonictourssl.com/snorkeling"
                />
                <SnorkelingPage />
              </>
            }
          />
          <Route
            path="/tea-tasting"
            element={
              <>
                <SEO
                  title="Ceylon Tea Tasting - Sonic Tours Sri Lanka"
                  description="Enjoy authentic Ceylon tea tasting and plantation visits with Sonic Tours."
                  keywords="Tea Tasting Sri Lanka, Sonic Tours, Ceylon Tea, Hill Country"
                  url="https://sonictourssl.com/tea-tasting"
                />
                <TeaTastingPage />
              </>
            }
          />
          <Route
            path="/temple-visit"
            element={
              <>
                <SEO
                  title="Temple Visits - Sonic Tours Sri Lanka"
                  description="Explore Sri Lanka's sacred temples and ancient heritage with guided tours from Sonic Tours."
                  keywords="Temple Visit Sri Lanka, Sonic Tours, Cultural Experiences"
                  url="https://sonictourssl.com/temple-visit"
                />
                <TempleVisitPage />
              </>
            }
          />
          <Route
            path="/wildlife-safari"
            element={
              <>
                <SEO
                  title="Wildlife Safari - Sonic Tours Sri Lanka"
                  description="Join unforgettable wildlife safaris in Sri Lanka's national parks with Sonic Tours."
                  keywords="Wildlife Safari Sri Lanka, Sonic Tours, Yala National Park, Udawalawe Elephants"
                  url="https://sonictourssl.com/wildlife-safari"
                />
                <WildlifeSafariPage />
              </>
            }
          />
        </Routes>
      </main>

      <WhatsApp />
      <TikTok />
      <Instagram />
      <Footer />
    </Router>
  );
};

export default App;